import React from "react";
import Container from "~/components/Container";
import styles from "./CollectionsContent.module.scss";

type Props = {
  data: string;
  is_artist?: boolean;
};

const CollectionsContent = ({ data, is_artist }: Props) => {
  if (!data || is_artist) return null;
  return (
    <Container>
      <div className={"blocks"} dangerouslySetInnerHTML={{ __html: data }} />
    </Container>
  );
};

export default CollectionsContent;
